/* import __COLOCATED_TEMPLATE__ from './toll-free-verification-required-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();